export const mockSurvey = {
  id: '407ba609-b3c6-4e79-b0b7-17806d40b204',
  respondents: [
    {
      id: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
      status: 'approved_by_user',
      sessionId: '9db96c1f-4010-4016-89eb-10a218cf9b7d',
      simpleId: '0001',
      state: 'DISTRICT OF COLUMBIA',
      age: 22,
      standardEmployment: 'Employed part-time',
      standardHHIUS: '$5,000 to $9,999',
      standardIndustryPersonal: 'Education',
      gender: 'Female',
      standardEducation: 'Other post high school vocational training',
      msIsMobile: true,
      region: 'West',
      responses: [
        {
          id: '5d41ef4a-870f-484a-9904-8daeeaa650be',
          status: 'approved_by_user',
          questionId: '10',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: 'Suhar',
          textAnswer: 'Option A',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '687d89c1-2b7c-4ba8-aed9-65d764b94f95',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: 'I dont know',
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '687d89c1-2b7c-4ba8-aed9-65d764b94f95',
          status: 'approved_by_user',
          questionId: '14',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: 'I dont know',
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '848facd8-1d40-485c-b215-f74206dcb11e',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Once per week',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'bca4426f-7b1d-4234-8de1-b61c25e0a2a3',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: 'bca4426f-7b1d-4234-8de1-b61c25e0a2a3',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: 'd08e3909-cb2f-4348-a91d-f2e210013591',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Sriracha',
            'Cajun spices',
            'Ranch',
            'Honey',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: 'd08e3909-cb2f-4348-a91d-f2e210013591',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Sriracha',
            'Cajun spices',
            'Ranch',
            'Honey',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: 'd7ffbe3c-fd26-4613-9ded-77343befd62f',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'e09eb80a-1541-4b3f-ab87-e26990af58f4',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'e31de2a0-ec15-4550-b3fc-ced654166fc4',
          status: 'approved_by_ds',
          questionId: '5',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Textura',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'ec1338a3-836a-4ca8-a887-bd1ad05698d1',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 3,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 5,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 5,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 3,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 2
          }
        },
        {
          id: 'ec1338a3-836a-4ca8-a887-bd1ad05698d1',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 3,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 5,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 5,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 3,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 2
          }
        },
        {
          id: 'f0cb4c2a-6036-4089-bf70-1aec08424bad',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'f0cb4c2a-6036-4089-bf70-1aec08424bad',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: 'd095e734-60ef-4be9-811e-678fd0e28e6e',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        }
      ]
    },
    {
      id: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
      status: 'approved_by_user',
      sessionId: '856d6490-9d56-47b8-bb48-57c2ff59e30b',
      simpleId: '0002',
      state: 'OHIO',
      age: 20,
      standardEmployment: 'Employed full-time',
      standardHHIUS: '$25,000 to $29,999',
      standardIndustryPersonal: 'Military',
      gender: 'Female',
      standardEducation: 'Associate Degree',
      msIsMobile: true,
      region: 'Northeast',
      responses: [
        {
          id: '1dfebc79-fb82-43b7-b45f-94d31d9e99b7',
          status: 'approved_by_user',
          questionId: '5',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'cheddar',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '435b7b28-3933-47cc-9e45-ed13bc2e9d12',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '4c50fe4a-8b6e-491b-b2f2-86edb6513f3d',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: 'i dont know why',
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '4c50fe4a-8b6e-491b-b2f2-86edb6513f3d',
          status: 'approved_by_ds',
          questionId: '14',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: 'i dont know why',
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '73cccf88-da4e-4c9d-b948-b74f9119cde4',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 3,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 3,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 1,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 4,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 5
          }
        },
        {
          id: '73cccf88-da4e-4c9d-b948-b74f9119cde4',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 3,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 3,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 1,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 4,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 5
          }
        },
        {
          id: '9186da8b-b61d-48b6-a690-15a0f4fd2b27',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Sriracha',
            'Other'
          ],
          textMapAnswer: null
        },
        {
          id: '9186da8b-b61d-48b6-a690-15a0f4fd2b27',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Sriracha',
            'Ranch'
          ],
          textMapAnswer: null
        },
        {
          id: 'bbe10ec5-b3b8-4120-b362-649033573977',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Once per month',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'bf2c5f1a-7ac3-4b8a-95e1-0deecdc0ed37',
          status: 'approved_by_ds',
          questionId: '10',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: 'I dont know why',
          textAnswer: 'Option B',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'c18e0ce8-6279-4da5-9aad-16e1c81bbedd',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'c18e0ce8-6279-4da5-9aad-16e1c81bbedd',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'de878613-c6fc-4076-944d-6aee0d36174f',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'fd3efdc3-a2ac-4faf-a5e1-2f86f9094ffc',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Ranch',
            'Honey BBQ',
            'Sriracha',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: 'fd3efdc3-a2ac-4faf-a5e1-2f86f9094ffc',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: '0eee1731-4cea-49e9-9df4-35ffb82a226b',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Ranch',
            'Honey BBQ',
            'Sriracha',
            'Cajun spices'
          ],
          textMapAnswer: null
        }
      ]
    },
    {
      id: '2eefb9af-3725-4f26-b4e5-484881027371',
      status: 'approved_by_user',
      sessionId: '6434e86a-3fcb-47f5-99f5-1c213dc17f74',
      simpleId: '0003',
      state: 'FLORIDA',
      age: 32,
      standardEmployment: 'Employed full-time',
      standardHHIUS: '$40,000 to $44,999',
      standardIndustryPersonal: 'Healthcare',
      gender: 'Male',
      standardEducation: 'Associate Degree',
      msIsMobile: true,
      region: 'Northeast',
      responses: [
        {
          id: '274e1f29-31a2-4247-b6d2-bb13a6e28363',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '73d02629-e710-4ef9-a3b3-5ac0a277405c',
          status: 'approved_by_user',
          questionId: '5',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Kettle corn',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '8249a658-f904-4d93-82c0-41f980fbe2a6',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey BBQ',
            'Honey',
            'Cajun spices',
            'Ranch',
            'Sriracha'
          ],
          textMapAnswer: null
        },
        {
          id: '8249a658-f904-4d93-82c0-41f980fbe2a6',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Honey BBQ',
            'Honey',
            'Cajun spices',
            'Sriracha'
          ],
          textMapAnswer: null
        },
        {
          id: 'c325af5b-7903-4313-a869-f82ed918f5a1',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'A few times per month',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'c66cc7e6-2e21-4ceb-85cf-462863b6a9ef',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'c66cc7e6-2e21-4ceb-85cf-462863b6a9ef',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'd69fee44-75cc-47de-85cb-ad2261eeaabf',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: 'd69fee44-75cc-47de-85cb-ad2261eeaabf',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: 'd7b9b5e2-4335-4c1b-94e6-46a8c5eadd0f',
          status: 'approved_by_ds',
          questionId: '10',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: 'No',
          textAnswer: 'Option B',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'df52b0b8-d88c-4a5f-9e1c-6f7295a739f3',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 5,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 3,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 4,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 1,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 4
          }
        },
        {
          id: 'df52b0b8-d88c-4a5f-9e1c-6f7295a739f3',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 5,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 3,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 4,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 1,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 4
          }
        },
        {
          id: 'f7539c81-582a-4ead-b2c3-32df46dc6a73',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'fa66c57b-4903-4c02-b4b9-143527d1ae7f',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: 'No',
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'fa66c57b-4903-4c02-b4b9-143527d1ae7f',
          status: 'approved_by_ds',
          questionId: '14',
          respondentSurveyId: '2eefb9af-3725-4f26-b4e5-484881027371',
          otherAnswer: null,
          explainAnswer: 'No',
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        }
      ]
    },
    {
      id: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
      status: 'approved_by_user',
      sessionId: '9d77e716-997e-4cd5-9f3d-ef017b280004',
      simpleId: '0004',
      state: 'SOUTH CAROLINA',
      age: 20,
      standardEmployment: 'Employed part-time',
      standardHHIUS: '$5,000 to $9,999',
      standardIndustryPersonal: "I don't work",
      gender: 'Female',
      standardEducation: 'High school graduate',
      msIsMobile: true,
      region: 'Midwest',
      responses: [
        {
          id: '003eb6d6-f7ed-44f7-b428-580a20394776',
          status: 'approved_by_user',
          questionId: '5',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Butter',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '155d1df7-faba-4e97-99b1-94d6802a93ea',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Cajun spices',
            'Sriracha',
            'Ranch',
            'Honey BBQ',
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: '155d1df7-faba-4e97-99b1-94d6802a93ea',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Cajun spices',
            'Sriracha',
            'Ranch',
            'Honey BBQ',
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: '69adf6ab-57b9-4943-9e25-9f6da8c2f5a4',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '71976efe-9da7-4106-b975-d524da742a7d',
          status: 'approved_by_ds',
          questionId: '10',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: 'They are the bomb and love eating them so much',
          textAnswer: 'None of the above',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '71cdbda8-4d47-4d6b-bd8d-6c1363b2850f',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'A few times per year',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '9f146a33-c85c-49de-9907-3c997ba8b6e9',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: 'Idk I just don’t like salt like that',
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '9f146a33-c85c-49de-9907-3c997ba8b6e9',
          status: 'approved_by_ds',
          questionId: '14',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: 'Idk I just don’t like salt like that',
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'a1f2fb71-1f95-4e13-9df3-53c8f6e53d01',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: 'a1f2fb71-1f95-4e13-9df3-53c8f6e53d01',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: 'd8140cdd-d3a7-44a7-a484-b92a830ff89a',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 2,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 2,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 1,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 2,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 1
          }
        },
        {
          id: 'd8140cdd-d3a7-44a7-a484-b92a830ff89a',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 2,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 2,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 1,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 2,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 1
          }
        },
        {
          id: 'd88a2718-b03a-4737-a96b-55ad2115599e',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'd88a2718-b03a-4737-a96b-55ad2115599e',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'd90ce776-1a79-4b0a-be7c-9a976dfb80f7',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: '26aec6cc-905b-4a1c-a489-20b9f0cbc3e5',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        }
      ]
    },
    {
      id: 'abc',
      status: 'approved_by_user',
      sessionId: '9d77e716-997e-4cd5-9f3d-ef017b280004',
      simpleId: '0004',
      state: 'SOUTH CAROLINA',
      age: 20,
      standardEmployment: 'Employed part-time',
      standardHHIUS: '$5,000 to $9,999',
      standardIndustryPersonal: "I don't work",
      gender: 'Female',
      standardEducation: 'High school graduate',
      msIsMobile: true,
      region: 'Midwest',
      responses: [
        {
          id: '003eb6d6-f7ed-44f7-b428-580a20394776',
          status: 'approved_by_user',
          questionId: '5',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Butter',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '155d1df7-faba-4e97-99b1-94d6802a93ea',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Cajun spices',
            'Sriracha',
            'Ranch',
            'Honey BBQ',
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: '155d1df7-faba-4e97-99b1-94d6802a93ea',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Cajun spices',
            'Sriracha',
            'Ranch',
            'Honey BBQ',
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: '69adf6ab-57b9-4943-9e25-9f6da8c2f5a4',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '71976efe-9da7-4106-b975-d524da742a7d',
          status: 'approved_by_ds',
          questionId: '10',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: 'They are the bomb and love eating them so much',
          textAnswer: 'None of the above',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '71cdbda8-4d47-4d6b-bd8d-6c1363b2850f',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'A few times per year',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '9f146a33-c85c-49de-9907-3c997ba8b6e9',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: 'Idk I just don’t like salt like that',
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '9f146a33-c85c-49de-9907-3c997ba8b6e9',
          status: 'approved_by_ds',
          questionId: '14',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: 'Idk I just don’t like salt like that',
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'a1f2fb71-1f95-4e13-9df3-53c8f6e53d01',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: 'a1f2fb71-1f95-4e13-9df3-53c8f6e53d01',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: 'd8140cdd-d3a7-44a7-a484-b92a830ff89a',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 2,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 2,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 1,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 2,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 1
          }
        },
        {
          id: 'd8140cdd-d3a7-44a7-a484-b92a830ff89a',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 2,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 2,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 1,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 2,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 1
          }
        },
        {
          id: 'd88a2718-b03a-4737-a96b-55ad2115599e',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'd88a2718-b03a-4737-a96b-55ad2115599e',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'd90ce776-1a79-4b0a-be7c-9a976dfb80f7',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: 'abc',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        }
      ]
    },
    {
      id: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
      status: 'approved_by_ds',
      sessionId: 'd543135d-1a56-4f6f-90af-333a3927b627',
      simpleId: '0006',
      state: 'OHIO',
      age: 23,
      standardEmployment: 'Self-employed part-time',
      standardHHIUS: '$5,000 to $9,999',
      standardIndustryPersonal: 'Chemicals/Plastics/Rubber',
      gender: 'Female',
      standardEducation: 'Associate Degree',
      msIsMobile: true,
      region: 'South',
      responses: [
        {
          id: '34c67bea-c8d6-447e-9d4c-b0a0c3650531',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 3,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 1,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 2,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 3,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 4
          }
        },
        {
          id: '34c67bea-c8d6-447e-9d4c-b0a0c3650531',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 3,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 1,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 2,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 3,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 4
          }
        },
        {
          id: '46e7d69b-6488-4cb5-b087-1048234172d4',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Once per week',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '60043174-da91-4bec-84a7-69f9b8dd03f8',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: '60043174-da91-4bec-84a7-69f9b8dd03f8',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: '7bccfa03-7d72-4fb5-bebc-cda1e7033a4b',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '7befd8a2-eb26-4e9b-860b-efc098fb39b3',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Sriracha',
            'Honey BBQ',
            'Cajun spices',
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: '7befd8a2-eb26-4e9b-860b-efc098fb39b3',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Sriracha',
            'Honey BBQ',
            'Cajun spices',
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: '809a59b2-8cdf-4621-b4a5-67fa56c8ac06',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: 'Nene',
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '809a59b2-8cdf-4621-b4a5-67fa56c8ac06',
          status: 'approved_by_ds',
          questionId: '14',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: 'Nene',
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '9e563122-8ebe-414e-b719-ea3ce3f7e9f4',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '7',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '9e563122-8ebe-414e-b719-ea3ce3f7e9f4',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '7',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'b04cd3c3-b638-4a38-ba9e-f4b5359b48a4',
          status: 'approved_by_ds',
          questionId: '10',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: 'Nene',
          textAnswer: 'Option A',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'b4379833-4cbe-4b7a-a69d-c947310fca55',
          status: 'approved_by_ds',
          questionId: '5',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Nsnd',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'd9a1535f-9925-49b3-bdd4-770cf6f5c4d3',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: 'ffeaa14c-5e6f-4eed-b6f6-93326bfb2a79',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '4',
          textArrayAnswer: null,
          textMapAnswer: null
        }
      ]
    },
    {
      id: '8f99dfa2-63dc-4441-9524-a3e714895e62',
      status: 'approved_by_user',
      sessionId: '71ade284-4a37-4b7f-8f97-f877c23f79b5',
      simpleId: '0007',
      state: 'ILLINOIS',
      age: 41,
      standardEmployment: 'Self-employed full-time',
      standardHHIUS: '$200,000 to $249,999',
      standardIndustryPersonal: 'Bio-Tech',
      gender: 'Male',
      standardEducation: 'Doctorate degree',
      msIsMobile: true,
      region: 'South',
      responses: [
        {
          id: '04d923f0-aa7a-49b7-abf1-11330e153eca',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 4,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 5,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 5,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 3,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 4
          }
        },
        {
          id: '04d923f0-aa7a-49b7-abf1-11330e153eca',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 4,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 5,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 5,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 3,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 4
          }
        },
        {
          id: '43490bcf-545a-44be-88a6-05c8d503837b',
          status: 'approved_by_ds',
          questionId: '10',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: 'The appearance is very nice 👌',
          textAnswer: 'Option A',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '584b8a11-c5af-40d2-afc0-e77e9beb5b7b',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Never',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '5dc704f7-567c-41c2-a80c-88b291eb4db5',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: 'Because I know you are not feeling well and will be there for the interview on',
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '5dc704f7-567c-41c2-a80c-88b291eb4db5',
          status: 'approved_by_ds',
          questionId: '14',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: 'Because I know you are not feeling well and will be there for the interview on',
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '5ec3ab71-b611-4b85-8ef0-fac27cc22e95',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Cajun spices',
            'Sriracha',
            'Honey BBQ',
            'Ranch'
          ],
          textMapAnswer: null
        },
        {
          id: '5ec3ab71-b611-4b85-8ef0-fac27cc22e95',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Cajun spices',
            'Sriracha',
            'Honey BBQ',
            'Ranch'
          ],
          textMapAnswer: null
        },
        {
          id: '63fc443c-7d89-4618-977b-dcb798c42c54',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '678be6b4-7b06-4c2f-bad1-f7d71e51558d',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: '678be6b4-7b06-4c2f-bad1-f7d71e51558d',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: '7534e267-32b0-4f9e-95a3-04273149ccf8',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '7',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '7534e267-32b0-4f9e-95a3-04273149ccf8',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '7',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '91ab3877-badf-47ab-92f1-66c12e976891',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'af887717-14f2-4aa6-b5b1-f614fedb779d',
          status: 'approved_by_ds',
          questionId: '5',
          respondentSurveyId: '8f99dfa2-63dc-4441-9524-a3e714895e62',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Milk ',
          textArrayAnswer: null,
          textMapAnswer: null
        }
      ]
    },
    {
      id: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
      status: 'approved_by_ds',
      sessionId: '44d3a1eb-b4e6-45bc-8321-a6bad6f45460',
      simpleId: '0008',
      state: 'CALIFORNIA',
      age: 56,
      standardEmployment: 'Employed full-time',
      standardHHIUS: '$150,000 to $174,999',
      standardIndustryPersonal: 'Computer Hardware',
      gender: 'Female',
      standardEducation: 'Masters degree',
      msIsMobile: true,
      region: 'West',
      responses: [
        {
          id: '0848d9ee-f44f-40e1-81c6-6bde5057fd49',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '1a85795b-b0bd-4c25-bca9-5bb9dccd4859',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: 'Nice and sweet ',
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '1a85795b-b0bd-4c25-bca9-5bb9dccd4859',
          status: 'approved_by_ds',
          questionId: '14',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: 'Nice and sweet ',
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '5c573642-820a-410e-8a7c-d73aa2ab6013',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 5,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 5,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 5,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 5,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 5
          }
        },
        {
          id: '5c573642-820a-410e-8a7c-d73aa2ab6013',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 5,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 5,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 5,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 5,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 5
          }
        },
        {
          id: '84b6220f-655f-43bf-bcfb-f46573b5a01b',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'A few times per week',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '91c243dd-16ed-4a4c-9d51-0590661555f7',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: '91c243dd-16ed-4a4c-9d51-0590661555f7',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Honey BBQ'
          ],
          textMapAnswer: null
        },
        {
          id: 'b0f5cff0-e336-42b7-b8e7-dd5fdf23eb06',
          status: 'approved_by_ds',
          questionId: '10',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: 'Very good service and ',
          textAnswer: 'Option B',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'b2180f79-a50f-46e3-a991-063199882b24',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Sriracha',
            'Honey',
            'Ranch',
            'Honey BBQ',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: 'b2180f79-a50f-46e3-a991-063199882b24',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Sriracha',
            'Honey',
            'Ranch',
            'Honey BBQ',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: 'bd85a41f-3819-40a7-9742-1a0bedccbaca',
          status: 'approved_by_user',
          questionId: '5',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Very good taste ',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'cf4461e1-2938-4074-8553-169c51ce8622',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'cf4461e1-2938-4074-8553-169c51ce8622',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'f58d4af3-13ec-45af-a96d-adebd273311c',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: '3d844071-6e14-4481-a4f8-d16e6872bb9a',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        }
      ]
    },
    {
      id: '34744008-17bc-43c0-812a-a403da50d656',
      status: 'approved_by_ds',
      sessionId: '172bf14b-e932-4e22-9494-4c60c7ca7e70',
      simpleId: '0010',
      state: 'TEXAS',
      age: 65,
      standardEmployment: 'Employed full-time',
      standardHHIUS: '$50,000 to $54,999',
      standardIndustryPersonal: 'Healthcare',
      gender: 'Female',
      standardEducation: 'High school graduate',
      msIsMobile: false,
      responses: [
        {
          id: '153f9c15-7644-40c1-aa19-4a186205d734',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '25418aeb-7cba-449a-904d-854e019ae1cb',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'A few times per month',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '3704fd69-4e3c-45c5-87b7-a384b663ae26',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: '3704fd69-4e3c-45c5-87b7-a384b663ae26',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Ranch',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: '388236e2-6ae0-4db7-9ad9-bebbf7f26b8b',
          status: 'approved_by_user',
          questionId: '5',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: "none, I don't like flavored popcorn",
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '67b97a8b-c794-4200-a90d-31e3d71d3ca5',
          status: 'approved_by_ds',
          questionId: '10',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: "I don't like hot cheese balls",
          textAnswer: 'Option A',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '88e2c20f-ddab-4766-859f-3897c84ee566',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '93e372de-d053-452a-886e-79ef0b3e648f',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '93e372de-d053-452a-886e-79ef0b3e648f',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '3',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '965043a8-0b53-4138-9593-1cf32e7c828a',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 1,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 1,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 1,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 1,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 1
          }
        },
        {
          id: '965043a8-0b53-4138-9593-1cf32e7c828a',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 1,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 1,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 1,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 1,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 1
          }
        },
        {
          id: 'b220cb64-b12d-461b-959e-33e45998e697',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Cajun spices',
            'Honey BBQ',
            'Honey',
            'Ranch',
            'Sriracha'
          ],
          textMapAnswer: null
        },
        {
          id: 'b220cb64-b12d-461b-959e-33e45998e697',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Cajun spices',
            'Honey BBQ',
            'Honey',
            'Ranch',
            'Sriracha'
          ],
          textMapAnswer: null
        },
        {
          id: 'd12b453d-90ae-4450-a5b9-dbe69a1db42c',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: 'I like a little salt',
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'd12b453d-90ae-4450-a5b9-dbe69a1db42c',
          status: 'approved_by_ds',
          questionId: '14',
          respondentSurveyId: '34744008-17bc-43c0-812a-a403da50d656',
          otherAnswer: null,
          explainAnswer: 'I like a little salt',
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        }
      ]
    },
    {
      id: '11',
      status: 'approved_by_ds',
      sessionId: '172bf14b-e932-4e22-9494-4c60c7ca7e71',
      simpleId: '0011',
      state: 'CALIFORNIA',
      age: 32,
      standardEmployment: 'Employed full-time',
      standardHHIUS: '$50,000 to $54,999',
      standardIndustryPersonal: 'Healthcare',
      gender: 'Male',
      standardEducation: 'High school graduate',
      msIsMobile: false,
      responses: [
        {
          id: '153f9c15-7644-40c1-aa19-4a186205d734',
          status: 'approved_by_ds',
          questionId: '9',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '2',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '25418aeb-7cba-449a-904d-854e019ae1cb',
          status: 'approved_by_ds',
          questionId: '1',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: 'Every day',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '3704fd69-4e3c-45c5-87b7-a384b663ae26',
          status: 'approved_by_ds',
          questionId: '4',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Other',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: '3704fd69-4e3c-45c5-87b7-a384b663ae26',
          status: 'approved_by_ds',
          questionId: '13',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Other',
            'Cajun spices'
          ],
          textMapAnswer: null
        },
        {
          id: '388236e2-6ae0-4db7-9ad9-bebbf7f26b8b',
          status: 'approved_by_user',
          questionId: '5',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: "none, I don't like flavored popcorn",
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '67b97a8b-c794-4200-a90d-31e3d71d3ca5',
          status: 'approved_by_ds',
          questionId: '10',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: "I don't like hot cheese balls",
          textAnswer: 'None of the above',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '88e2c20f-ddab-4766-859f-3897c84ee566',
          status: 'approved_by_ds',
          questionId: '7',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '1',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '93e372de-d053-452a-886e-79ef0b3e648f',
          status: 'approved_by_ds',
          questionId: '8',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '93e372de-d053-452a-886e-79ef0b3e648f',
          status: 'approved_by_ds',
          questionId: '15',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: '5',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: '965043a8-0b53-4138-9593-1cf32e7c828a',
          status: 'approved_by_ds',
          questionId: '3',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 4,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 4,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 3,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 4,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 3
          }
        },
        {
          id: '965043a8-0b53-4138-9593-1cf32e7c828a',
          status: 'approved_by_ds',
          questionId: '12',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: null,
          textMapAnswer: {
            '+qeFgBG5D1hcoP9jt5jNitnKlzE=': 4,
            'IrzuJukus/Zr9XL9fSQuY0gpf3U=': 4,
            'TD46uO4cGGAecWHXgQ6ip0ofHew=': 3,
            'UIthvB7lWkNV1ymGOGFwJ6LeC9U=': 4,
            'czF2HCpsoBVKNfvvAMZF8Ny3YZU=': 3
          }
        },
        {
          id: 'b220cb64-b12d-461b-959e-33e45998e697',
          status: 'approved_by_ds',
          questionId: '2',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey BBQ',
            'Ranch',
            'Cajun spices',
            'Sriracha',
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: 'b220cb64-b12d-461b-959e-33e45998e697',
          status: 'approved_by_ds',
          questionId: '11',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: null,
          textAnswer: null,
          textArrayAnswer: [
            'Honey BBQ',
            'Ranch',
            'Cajun spices',
            'Sriracha',
            'Honey'
          ],
          textMapAnswer: null
        },
        {
          id: 'd12b453d-90ae-4450-a5b9-dbe69a1db42c',
          status: 'approved_by_ds',
          questionId: '6',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: 'I like a little salt',
          textAnswer: '4',
          textArrayAnswer: null,
          textMapAnswer: null
        },
        {
          id: 'd12b453d-90ae-4450-a5b9-dbe69a1db42c',
          status: 'approved_by_ds',
          questionId: '14',
          respondentSurveyId: '11',
          otherAnswer: null,
          explainAnswer: 'I like a little salt',
          textAnswer: '4',
          textArrayAnswer: null,
          textMapAnswer: null
        }
      ]
    }
  ],
  questions: [
    {
      id: '1',
      type: 'single-select',
      text: 'How frequently do you<!---client-info-start-->&nbsp;purchase popcorn?',
      order: 1,
      qualifyingTags: [],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: [
        {
          id: 477086,
          text: 'Every day',
          order: 0,
          qualificationTags: [
            '1_ovsunk2qg6'
          ],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477087,
          text: 'A few times per week',
          order: 1,
          qualificationTags: [
            '1_ovsunk2qg6'
          ],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477088,
          text: 'Once per week',
          order: 2,
          qualificationTags: [
            '1_ovsunk2qg6'
          ],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477089,
          text: 'A few times per month',
          order: 3,
          qualificationTags: [
            '1_ovsunk2qg6'
          ],
          shuffle: false,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477090,
          text: 'Once per month',
          order: 4,
          qualificationTags: [
            '1_ovsunk2qg6'
          ],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477091,
          text: 'A few times per year',
          order: 5,
          qualificationTags: [],
          shuffle: false,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477092,
          text: 'Never',
          order: 6,
          qualificationTags: [],
          shuffle: false,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        }
      ]
    },
    {
      id: '2',
      type: 'rank',
      text: 'Please rank the following popcorn flavors from <b>m</b><strong>ost interested</strong> to <strong>least interested.</strong>',
      order: 2,
      qualifyingTags: [
        '1_ovsunk2qg6'
      ],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: [
        {
          id: 477093,
          text: 'Ranch',
          order: 0,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477094,
          text: 'Sriracha',
          order: 1,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477095,
          text: 'Honey',
          order: 2,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477096,
          text: 'Cajun spices',
          order: 3,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477097,
          text: 'Honey BBQ',
          order: 4,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        }
      ]
    },
    {
      id: '3',
      type: 'matrix-likert',
      text: 'Please rate how interested or not interested you are in these <b>popcorn flavors.</b>',
      order: 3,
      qualifyingTags: [
        '1_ovsunk2qg6'
      ],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: 'Not at all interested',
        maxLabel: 'Extremely interested',
        minRating: 1,
        maxRating: 5
      },
      options: [
        {
          id: 477098,
          text: 'Ranch',
          order: 0,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477099,
          text: 'Sriracha',
          order: 1,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477100,
          text: 'Honey',
          order: 2,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477101,
          text: 'Cajun spices',
          order: 3,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477102,
          text: 'Honey BBQ',
          order: 4,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        }
      ]
    },
    {
      id: '4',
      type: 'multi-select',
      text: "Please select your <b>Top 2 </b>potential&nbsp;flavors for popcorn you'd be most interested in.&nbsp;",
      order: 4,
      qualifyingTags: [
        '1_ovsunk2qg6'
      ],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: [
        {
          id: 477103,
          text: 'Ranch',
          order: 0,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477104,
          text: 'Sriracha',
          order: 1,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477105,
          text: 'Honey',
          order: 2,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477106,
          text: 'Cajun spices',
          order: 3,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477107,
          text: 'Honey BBQ',
          order: 4,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477108,
          text: 'Other',
          order: 5,
          qualificationTags: [],
          shuffle: false,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        }
      ]
    },
    {
      id: '5',
      type: 'textarea',
      text: 'What other flavors, if any, would you like to see on <b>popcorn</b>? <i>Please explain your answer in detail.&nbsp;</i>',
      order: 5,
      qualifyingTags: [
        '1_ovsunk2qg6'
      ],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: []
    },
    {
      id: '6',
      type: 'rate',
      text: 'How interested or not interested would you be in popcorn that had <strong>no salt?</strong>',
      order: 6,
      qualifyingTags: [],
      hasExplainOpt: true,
      scaleProperties: {
        minLabel: 'Not at all intersted',
        maxLabel: 'Extremely interested',
        minRating: 1,
        maxRating: 5
      },
      options: []
    },
    {
      id: '7',
      type: 'rate-only',
      text: 'How interested or not interested would you be in popcorn that had <strong>no sugar?</strong>',
      order: 7,
      qualifyingTags: [],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: 'Not at all interested',
        maxLabel: 'Extremely interested',
        minRating: 1,
        maxRating: 5
      },
      options: []
    },
    {
      id: '8',
      type: 'number',
      text: 'How many times in a week do you eat popcorn?&nbsp;',
      order: 8,
      qualifyingTags: [],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: []
    },
    {
      id: '9',
      type: 'variant',
      text: 'Variants',
      order: 9,
      qualifyingTags: [],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: [
        {
          id: 477109,
          text: 'Please CLICK ON THE IMAGE BELOW to open in a separate tab of your browser.<br><br>Take a few moments to review this image in its entirety until you have a sense for the information.<br><br>When you are finished, return here and click “Next" to begin the survey.',
          order: 0,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: require('@/assets/img/handsomeCat.png'),
          // link: 'https://learnvest.invisionapp.com/share/4VOSNCHEGWK#/screens/327879139_Sticky_Right-Rail_Nav',
          label: 'Variant A'
        },
        {
          id: 477110,
          text: 'Please CLICK ON THE IMAGE BELOW to open in a separate tab of your browser.<br><br>Take a few moments to review this image in its entirety until you have a sense for the information.<br><br>When you are finished, return here and click “Next" to begin the survey.',
          order: 1,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: require('@/assets/img/handsomeCat2.png'),
          // link: 'https://learnvest.invisionapp.com/share/4VOSNCHEGWK#/screens/327879139_Sticky_Right-Rail_Nav',
          label: 'Variant B'
        }
      ]
    },
    {
      id: '10',
      type: 'single-select',
      text: '<strong>Which of the following stood out to you the most?</strong>',
      order: 10,
      qualifyingTags: [],
      hasExplainOpt: true,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: [
        {
          id: 477111,
          text: 'Option A',
          order: 0,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477112,
          text: 'Option B',
          order: 1,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477113,
          text: 'None of the above',
          order: 2,
          qualificationTags: [],
          shuffle: false,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        }
      ]
    },
    {
      id: '11',
      type: 'rank',
      text: 'Please rank the following popcorn flavors from <b>m</b><strong>ost interested</strong> to <strong>least interested.</strong>',
      order: 11,
      qualifyingTags: [
        '1_ovsunk2qg6'
      ],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: [
        {
          id: 477093,
          text: 'Ranch',
          order: 0,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477094,
          text: 'Sriracha',
          order: 1,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477095,
          text: 'Honey',
          order: 2,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477096,
          text: 'Cajun spices',
          order: 3,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477097,
          text: 'Honey BBQ',
          order: 4,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        }
      ]
    },
    {
      id: '12',
      type: 'matrix-likert',
      text: 'Please rate how interested or not interested you are in these <b>popcorn flavors.</b>',
      order: 12,
      qualifyingTags: [
        '1_ovsunk2qg6'
      ],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: 'Not at all interested',
        maxLabel: 'Extremely interested',
        minRating: 1,
        maxRating: 5
      },
      options: [
        {
          id: 477098,
          text: 'Ranch',
          order: 0,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477099,
          text: 'Sriracha',
          order: 1,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477100,
          text: 'Honey',
          order: 2,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477101,
          text: 'Cajun spices',
          order: 3,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477102,
          text: 'Honey BBQ',
          order: 4,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        }
      ]
    },
    {
      id: '13',
      type: 'multi-select',
      text: "Please select your <b>Top 2 </b>potential&nbsp;flavors for popcorn you'd be most interested in.&nbsp;",
      order: 13,
      qualifyingTags: [
        '1_ovsunk2qg6'
      ],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: [
        {
          id: 477103,
          text: 'Ranch',
          order: 0,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477104,
          text: 'Sriracha',
          order: 1,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477105,
          text: 'Honey',
          order: 2,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477106,
          text: 'Cajun spices',
          order: 3,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477107,
          text: 'Honey BBQ',
          order: 4,
          qualificationTags: [],
          shuffle: true,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        },
        {
          id: 477108,
          text: 'Other',
          order: 5,
          qualificationTags: [],
          shuffle: false,
          isTerminating: true,
          isCorrectOption: false,
          image: null
        }
      ]
    },
    {
      id: '14',
      type: 'rate',
      text: 'How interested or not interested would you be in popcorn that had <strong>no salt?</strong>',
      order: 14,
      qualifyingTags: [],
      hasExplainOpt: true,
      scaleProperties: {
        minLabel: 'Not at all intersted',
        maxLabel: 'Extremely interested',
        minRating: 1,
        maxRating: 5
      },
      options: []
    },
    {
      id: '15',
      type: 'number',
      text: 'How many times in a week do you eat popcorn?&nbsp;',
      order: 15,
      qualifyingTags: [],
      hasExplainOpt: false,
      scaleProperties: {
        minLabel: null,
        maxLabel: null,
        minRating: null,
        maxRating: null
      },
      options: []
    }
  ]
}
